import React from 'react'
// import '../assets/css/button.scss'

export type ButtonProps = {
	/** 버튼 안의 내용 */
	children: React.ReactNode;
	/** 클릭했을 때 호출되는 함수 */
	onClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
	/** 버튼의 크기를 결정합니다. */
	size?: 'small' | 'medium' | 'large' | 'x-large' | 'wide' | 'block' | 'super' | 'icon large'
	/** 버튼의 색상을 결정합니다. */
	color?: 'primary' | 'secondary' | 'tertiary' | 'blue' | 'f' | 'yellow' | 'green' | 'red' | 'gray' | 'white'
	/** 비활성화 여부를 결정합니다. */
	disable?: '' | 'disable'
	/** 스타일을 결정합니다. */
	style?: '--' | 'line gray'
	/** icon유무를 결정합니다. */
	icon?: '' | 'icon'
}

/** `Button` 컴포넌트는 어떠한 작업을 트리거 할 때 사용합니다.*/
function Button(props: ButtonProps) {
	const { children, size, onClick, color, disable, style, icon } = props

	return (
		<button
			className={`btn ${size} ${color} ${disable} ${style} ${icon}`}
			onClick={onClick}
		>{children}
		</button>
	)
}

export default Button;